import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency, LazyImage, SvgIcon } from '@teko/ui';
import { PromotionType } from '../../types.es.js';
import { PromotionInfo } from '../Promotion/PromotionInfo/PromotionInfo.es.js';

const Quantity = styled.span`
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Benefit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Label = styled.div`
  font-size: 0.75rem;
  flex: 1;
`;
const Coupon = styled.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 12px;
`;
const Discount = styled(Currency)`
  margin-left: 4px;
  font-weight: bold;
`;
const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = styled(PriceWrapper)`
  margin-top: 8px;
`;
const PromotionIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Applied = styled.div`
  background: #30cd60;
  border-radius: 4px;
  padding: 2px 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  display: inline-block;
`;
const PromotionDetail = ({
  promotion,
  className
}) => {
  var _a, _b;
  return /* @__PURE__ */ React.createElement(Benefit, {
    className
  }, promotion.type === PromotionType.PRODUCT ? /* @__PURE__ */ React.createElement(React.Fragment, null, promotion.benefit.money && !!promotion.benefit.money && promotion.benefit.money.map((moneyPromotion) => /* @__PURE__ */ React.createElement(Label, {
    key: moneyPromotion.id
  }, t("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ React.createElement(Discount, {
    value: moneyPromotion.money || 0
  }), " ", /* @__PURE__ */ React.createElement(Applied, null, t("\u0110\xE3 \xE1p d\u1EE5ng")))), promotion.benefit.items && !!promotion.benefit.items && promotion.benefit.items.map((gift) => {
    var _a2;
    return /* @__PURE__ */ React.createElement(GiftWrapper, {
      key: gift.name
    }, /* @__PURE__ */ React.createElement(GiftImage, null, /* @__PURE__ */ React.createElement(LazyImage, {
      borderRadius: 4,
      contain: true,
      src: ((_a2 = gift.image) == null ? void 0 : _a2.src) || ""
    })), /* @__PURE__ */ React.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ React.createElement(Label, null, gift.name));
  })) : /* @__PURE__ */ React.createElement(GiftWrapper, null, /* @__PURE__ */ React.createElement(PromotionIcon, null, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  })), /* @__PURE__ */ React.createElement(Label, null, t("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), " ", /* @__PURE__ */ React.createElement(Coupon, null, " ", (_a = promotion.condition) == null ? void 0 : _a.coupon, " "), " ", t("gi\u1EA3m"), /* @__PURE__ */ React.createElement(PromotionInfo, {
    money: (_b = promotion.benefit.money) == null ? void 0 : _b[0],
    condition: promotion.condition || null
  }))));
};

export { PromotionDetail };
